<template>
    <div>
        <div @click="$parent.$parent.$emit('open', data)" :class="classes" :style="'background: '+ color +';'">
            <div v-if="data && data.relation && data.relation.instance">
                <span class="registration small" style="color: #000; margin-top: 0; display: inline-block;">{{ data.relation.instance.vehicle.registration.formatted_vrm }}
                </span>
                <div v-if="data.relation.comments_count && data.relation.comments_count > 0" style="position: absolute; right:.5rem; top: .5rem; color: rgb(130, 156, 175)">
                    <span class="material-icons" style="vertical-align: middle; font-size: 1rem;">comment</span>
                    <span style="vertical-align: middle;">{{ data.relation.comments_count }}</span>
                </div>
                <span style="display: inline-block; font-weight: bold;">{{ data.relation.instance.title }}</span>
                <contact-name-and-details
                    style="font-weight: bold;"
                    link-colour="#000"
                    :contact="data.relation.contact"
                />
                <div style="position: relative;">
                    <div>&nbsp;</div>
                    <div style="position: absolute; left: 0; right: 0; top:0;">
                        <div class="truncate" style="max-width: 100%;">{{ data.relation.description }}</div>
                    </div>
                </div>
                <span v-if="shouldShowTime" style="font-weight: bold;">
                    {{ data.from | formatTime }}
                </span>
                <booking-tag-cloud 
                    :booking="data.relation" 
                    style="max-width: calc(100% - 24px);"
                />
                <avatar 
                    :size="24"
                    v-if="data.relation.assignee" 
                    :user="data.relation.assignee" 
                    label-prefix="Assigned to "
                    style="position: absolute; bottom: 0; right: 20px;" 
                />
            </div>
            <div v-else>
                <div style="padding: .25rem; font-weight: bold;">
                    <span class="material-icons" style="vertical-align: middle; color: #be57da;">info</span>
                    <span style="vertical-align: middle;">{{ data.description }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .scheduler-container .scheduler-outer-pane-container .scheduler-outer-right-pane .scheduler-inner-pane .scheduler-layout-container .scheduler-data-layout .scheduler-item {
        position: relative;
        color: #333;
        padding: .5rem;
        font-size: .9rem;
        margin: .5rem .75rem;
        cursor: pointer;
        white-space: normal;
    }
</style>

<script>
    import { BookingPresenceStatuses } from '../../classes/Api/Booking'
    import BookingTagCloud from './BookingTagCloud'
    import Moment from 'moment'
    import BookingUiHelpers from './BookingUiHelpers'

    export default {
        mixins: [BookingUiHelpers],
        props: ['data'],
        components: { BookingTagCloud },
        filters: {
            formatTime(value) {
                return new Moment(value).format('H:mma')
            }
        },
        data() {
            return {
                BookingPresenceStatuses
            }
        },
        computed: {
            shouldShowTime() {
                let date = (new Moment(this.data.from));
                
                return date.hour() !== 0 ? true : false;
            },
            classes() {
                let list = ['scheduler-item']

                if (this.data._display_state === 'continuation') {
                    list.push('scheduler-is-continuation')
                } else if (this.data._display_state === 'curtailed') {
                    list.push('scheduler-is-curtailed')
                }

                return list
            },
            color() {
                if (!this.data.relation) {
                    return '#be57da50';
                }

                if (this.data.relation && Moment(this.data.to).isBefore() && (
                    !this.data.relation.completed_at || !this.bookingTasksComplete(this.data.relation)
                )) {
                    return 'repeating-linear-gradient(45deg,#feeed080,#feeed080 10px,#feeed0 10px,#feeed0 20px);'
                }

                if (this.data.relation && this.data.relation.completed_at) {
                    return '#d9f5d280';
                }
                
                return '#d0ebfe80';
            }
        }
    }
</script>